import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import {} from '../helpers/icons';
import { TabHeaderItem } from './tabItem';
import { HelpIcon, HelpIconContainer } from '../helpIconContainer';
import { Icon } from '../icon';

const TabHeaderContainer = styled.ul<{ fillItems?: boolean }>`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    overflow-x: auto;
    justify-content: stretch;

    ${(props) =>
        props.fillItems &&
        `
    ${TabHeaderItemStyled} {
      flex: 1;
    }
  `}
`;

const ImgContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    width: 100%;
    ${Icon} {
        height: 70px;
        width: 100%;
    }
`;
const TabHeaderItemStyled = styled.ul<{ active?: boolean }>`
    padding: ${(props) => props.theme.app.component.tabs.padding};
    font-size: ${(props) => props.theme.app.component.tabs.fontSize};
    text-align: center;
    background-color: ${(props) => props.theme.app.component.tabs.backgroundColor};
    min-width: 150px;
    user-select: none;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: ${(props) => props.theme.app.component.tabs.hover.backgroundColor};
    }

    ${(props) =>
        props.active &&
        `
      color:  ${props.theme.app.component.tabs.active.textColor};
      background-color:  ${props.theme.app.component.tabs.active.backgroundColor};
      border-bottom-style: solid;
      border-bottom-color:  ${props.theme.app.component.tabs.active.borderBottomColor};
      border-bottom-size: 15px;
  `}

    ${Icon} {
        margin-left: 10px;
    }
`;

export interface TabProps<T extends string> {
    items: TabHeaderItem<T>[];
    selectedItemKey: string | null;
    fillItems?: boolean;
    onTabSelected: (item: TabHeaderItem<T>) => void;
}

export const TabHeader = <T extends string>({ items, selectedItemKey, fillItems, onTabSelected }: PropsWithChildren<TabProps<T>>) => {
    return (
        <TabHeaderContainer fillItems={fillItems}>
            {items.map((item) => {
                return (
                    <TabHeaderItemStyled key={item.key} active={selectedItemKey == item.key} onClick={() => onTabSelected(item)}>
                        <span>{item.label}</span>
                        {item.tooltip && (
                            <HelpIconContainer tooltip={item.tooltip as React.ReactElement<any>}>
                                <HelpIcon />
                            </HelpIconContainer>
                        )}
                        {item.icon && <ImgContainer>{item.icon}</ImgContainer>}
                    </TabHeaderItemStyled>
                );
            })}
        </TabHeaderContainer>
    );
};
